import { credit } from 'constants/credit'

/* Fornula para el calculo de la cuota en base a un plazo, capital inicial y tasa de interes
    A = VP ((i(1 + i)^n) / ((1 + i)^n – 1))
*/
export const quotaFormula = (amount: string) => {
  const regex = /\./g
  const capital = parseInt(amount.replace(regex, ''),10)
  return credit.terms.map((term) => {
    return quotaSingleFormula(capital, term)
  })
}

export const quotaSingleFormula = (capital: number, term: number) => {
  const efectiveRate = credit.rate / credit.paymentPeriod
  const numerator = efectiveRate * Math.pow(1 + efectiveRate, term)
  const denominator = Math.pow(1 + efectiveRate, term) - 1
  const quota = capital * (numerator / denominator)
  const queotaWithInsurance = quota + ((1.1232 / 100) * capital * 30) / 360
  const totalInterest = calcTotalInterest(term, capital, quota)
  const insurance = totalInterest * (10.83 / 100) 
  const totalAPagar =
    capital +
    parseFloat(totalInterest.toFixed(2)) +
    parseFloat(insurance.toFixed(2))
  const numberFormater = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
  })
  return {
    capital: capital.toLocaleString('de-DE'),
    term: term,
    quota: numberFormater.format(Number(queotaWithInsurance.toFixed(2))),
    totalInterest: numberFormater.format(Number(totalInterest.toFixed(2))),
    seguro: numberFormater.format(Number(insurance.toFixed(2))),
    total: numberFormater.format(Number(totalAPagar.toFixed(2))),
  }
}

const calcTotalInterest = (term: number, capital: number, quota: number) => {
  let balance = capital
  const quotasRate: number[] = []
  for (let i = 0; i < term; i++) {
    const quotaRate = (balance * credit.rate) / credit.paymentPeriod
    balance = balance - (quota - quotaRate)
    quotasRate.push(quotaRate)
  }
  return quotasRate.reduce((a, b) => a + b, 0)
}

